import { gql } from '@apollo/client';

export const GET_MATCH = gql`
  query GetMatch($matchId: ID!) {
    getMatch(matchId: $matchId) {
      id
      matchDate
      goalsHome
      goalsAway
      status
      statsCalculatedAt
      homeTeam {
        id
        nameShow
        shortName
        shield
        shieldPng
      }
      awayTeam {
        id
        nameShow
        shortName
        shield
        shieldPng
      }
      matchPlayers {
        id
        player {
          id
          nick
          image
          role
        }
        team {
          id
          shortName
          shield
          shieldPng
        }
        starterPosition
        minutesPlayed
        goals
        penaltyGoals
        ownGoals
        yellowCards
        redCard
        teamGoals
        rivalGoals
        fantasyScore
      }
      events {
        id
        eventType
        minute
        player {
          id
          nick
        }
      }
    }
  }
`;
